<template>
  <div class="fun_container">
    <div class="container">
      <FuncSearchGallery />

      <div class="row">
        <div class="col-xs-12">
          <img
            v-bind:src="app_root + `/assets/common/img/fun/designpaper/image/` + designId + `.jpg`"
            class="design-image img-responsive center-block"
          />
          <PrintButton class="designpaper-printbtn" v-bind="contentsInfo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FuncSearchGallery from "../components/FuncSearchGallery";
import PrintButton from "../components/PrintButton";
import { LAUNCH_TYPE, CONTENT_TYPE } from "@/common/contentsinfo";
import { mapGetters } from "vuex";

export default {
  name: "DesignPaperSample",
  props: {
    designId: String,
  },
  components: {
    FuncSearchGallery,
    PrintButton
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapGetters(["getDesignPaperParameters"]),
    contentsInfo: function () {
      return {
        launchType: LAUNCH_TYPE.print,
        fcontId: this.getDesignPaperParameters.articleIdToSamplePage,
        contentType: CONTENT_TYPE.designpaper,
        designId: this.designId
      }
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages["0-132"],
    }
  }
};
</script>

<style scoped>
div.container {
  padding-left: 0px;
  padding-right: 0px;
}

img.design-image {
  margin-top: 10px;
  transition: all 400ms ease 0s;
  border: 0;
  width: 40%;
}

img.design-image:hover {
  box-shadow: 0px 0px 10px 2px #a9a9a9;
  -moz-box-shadow: 0px 0px 10px 2px #a9a9a9;
  -webkit-box-shadow: 0px 0px 10px 2px #a9a9a9;
}

.designpaper-printbtn {
  width: 40%;
  margin: 0 auto;
}

@media screen and (max-width: 767px) {
  img.design-image {
    width: 60%;
  }

  .designpaper-printbtn {
    width: 60%;
  }
}

@media screen and (max-width: 480px) {
  img.design-image {
    width: 70%;
  }

  .designpaper-printbtn {
    width: 70%;
  }
}
</style>